import { createContext, useContext } from "react";
import * as React from "react";
import PageLoader from "Components/PageLoader";
import 'firebase/compat/auth';
import {IUserDto} from "../Apis/Models/IUserDto";
import {useUserContext as useUserContextRequest} from "../Apis/UserContextApi";

type ContextProps = {
    user: IUserDto;
}
export const UserContextProvider = createContext<ContextProps>({
    user: {} as IUserDto,
});
interface Props {
    children: React.ReactNode;
}
const UserProvider = (props: Props) => {

    const { data : userContext } = useUserContextRequest();
    
    if (!userContext) {
        return <PageLoader shown={true}><></></PageLoader>
    }
    
    return (
        <UserContextProvider.Provider value={{user: userContext}}>
            <PageLoader shown={(!userContext)}>
                {props.children}
            </PageLoader>
        </UserContextProvider.Provider>
    )
}

export default UserProvider

export const useUserContext = () => {
    return useContext(UserContextProvider);
}
